// @ts-nocheck
import {
  Box,
  Button,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { AiOutlinePlus } from 'react-icons/ai';
import { FaEye, FaFileSignature, FaSearch } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { useHistory, useParams } from 'react-router-dom';
import { useManajemenPengetahuanContext } from '../../../controller/admin/manajemen_pengetahuan';
import { useManajemenPengetahuanKontenPemateriContext } from '../../../controller/admin/manajemen_pengetahuan/konten-pemateri';
import { useRole } from '../../../../hooks/useRole';
import Loader from '../../Loader';
import ModalSertifikat from '../ModalPengetahuan/ModalSertifikat';
import ModalTteSertifikat from '../ModalPengetahuan/ModalTteSertifikat';
import Pusher from 'pusher-js';
import { BiCheckCircle } from 'react-icons/bi';

/**
 * The KontenPemateri component displays a table of speakers' data within a knowledge management system.
 * This component handles various functionalities, including pagination, search, and data management of the speakers.
 *
 * @component
 * @returns {React.ReactElement} - Returns the KontenPemateri component.
 * @author Bagas Prasetyadi
 */

const KontenPemateri = () => {
  const history = useHistory();
  const { id } = useParams() as { id: string };
  const {
    pengetahuanItem,
    isKlinikKhususServer,
    isKategoriKlinikServer,
  } = useManajemenPengetahuanContext().state;
  const {
    listData,
    keyword,
    totalListData,
    page,
    perPage,
    isLoadingData,
    isOpenModalTteSertifikat,
    accountTTESelected,
    isLoadingTTEPemateri,
    isLoadingGenerateExcel,
    isLoadingDownloadExcel,
    isGenerateJobRunning,
    generatePengetahuanId,
  } = useManajemenPengetahuanKontenPemateriContext().state;
  const {
    setPengetahuanKontenPemateri: setState,
    fetchData,
    generateExcel,
    downloadExcel,
    tteSertifikatPemateri,
  } = useManajemenPengetahuanKontenPemateriContext().disptach;

  const { canMutate } = useRole();
  const isSubTema =
    isKlinikKhususServer && isKategoriKlinikServer === 'SUB';
  const showTteAction = canMutate && !isSubTema;

  const handlePerRowsChange = (newPerPage) => {
    setState('page', 1);
    setState('perPage', newPerPage);
  };

  const handlePageChange = (page) => {
    setState('page', page);
  };

  const columns: any[] = [
    {
      name: 'NO.',
      selector: (row, index) => index + 1,
      width: '80px',
    },
    {
      name: 'NAMA',
      selector: (row) => row?.nama_pemateri,
      sortable: true,
      wrap: true,
      width: '200px',
    },
    {
      name: 'JUDUL MATERI',
      selector: (row) => row?.judul,
      sortable: true,
      wrap: true,
      width: '200px',
    },
    ...(pengetahuanItem?.jenis_pengetahuan === 'synchronized'
      ? [
          {
            name: 'WAKTU',
            sortable: true,
            cell: (row) => {
              return (
                <Text>
                  {row.tanggal_mulai} - {row.waktu_mulai}
                </Text>
              );
            },
            wrap: true,
            width: '230px',
          },
        ]
      : []),
    {
      name: 'QUIZ',
      selector: (row) => row.has_quiz,
      sortable: true,
      cell: (row) => {
        const textColor = row?.has_quiz ? 'green' : 'gray';
        const textLabel = row?.has_quiz ? 'Tersedia' : 'Tidak Tersedia';
        const textWeight = row?.has_quiz ? 'semibold' : 'normal';
        return (
          <Text color={textColor} fontWeight={textWeight}>
            {textLabel}
          </Text>
        );
      },
      wrap: true,
    },
    {
      name: 'ASSIGNMENT',
      selector: (row) => row?.has_assessment,
      sortable: true,
      cell: (row) => {
        const textColor = row?.has_assessment ? 'green' : 'gray';
        const textLabel = row?.has_assessment ? 'Tersedia' : 'Tidak Tersedia';
        const textWeight = row?.has_assessment ? 'semibold' : 'normal';
        return (
          <Text color={textColor} fontWeight={textWeight}>
            {textLabel}
          </Text>
        );
      },
      wrap: true,
    },
    {
      name: 'AKSI',
      cell: (row, index) => {
        return (
          <Flex gridGap="2" flexWrap="wrap" py={2}>
            <Button
              colorScheme="blue"
              leftIcon={<Icon as={FaEye} />}
              onClick={() =>
                history.push(
                  `/admin/manajemen_pengetahuan/${pengetahuanItem?.id}/konten_pemateri/${row?.id}`
                )
              }
            >
              Detail Pemateri
            </Button>

            {showTteAction && !row.path_certificate_url && (
              <Button
                colorScheme="green"
                leftIcon={<Icon as={FaFileSignature} />}
                onClick={() => {
                  setState('ttePengetahuanId', row.pengetahuan_id);
                  setState('ttePemateriId', row.pemateri_id);
                  setState('isTteUlang', false);
                  setState('accountTTESelected', null);
                  setState('isOpenModalTteSertifikat', true);
                }}
              >
                TTE Sertifikat
              </Button>
            )}

            {showTteAction && row.path_certificate_url && (
              <>
                <Button
                  colorScheme="gray"
                  leftIcon={<Icon as={FaFileSignature} />}
                  onClick={() => {
                    setState('ttePengetahuanId', row.pengetahuan_id);
                    setState('ttePemateriId', row.pemateri_id);
                    setState('isTteUlang', true);
                    setState('accountTTESelected', null);
                    setState('isOpenModalTteSertifikat', true);
                  }}
                >
                  Regenerate Sertifikat
                </Button>
                <ModalSertifikat
                  id={row.pengetahuan_id}
                  urlSertifikat={row.path_certificate_url}
                  name={row.nama_pemateri}
                />
              </>
            )}
          </Flex>
        );
      },
      wrap: true,
      width: '320px',
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#F2FFFB',
        fontWeight: '900',
        fontSize: '13px',
      },
    },
  };

  const pusherApiKey = process.env.REACT_APP_PUSHER_API_KEY || '';
  const pusherCluster = process.env.REACT_APP_PUSHER_CLUSTER || '';

  useEffect(() => {
    const pusher = new Pusher(pusherApiKey, {
      cluster: pusherCluster,
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
    });
    const channel = pusher.subscribe('job-channel');

    channel.bind('generate.excel.pengetahuan_pemateri', function (data) {
      if (data.pengetahuan_id === Number(id)) {
        setState('generatePengetahuanId', (prevState) => [
          ...prevState,
          data.pengetahuan_id,
        ]);
        setState('isGenerateJobRunning', false);
      }
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pusherApiKey, pusherCluster]);

  useEffect(() => {
    fetchData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, page, perPage]);

  return (
    <>
      <Box bg="white" p={4}>
        <Flex justifyContent="space-between" alignItems="start" mb={4}>
          {canMutate ? (
            <Button
              colorScheme="blue"
              leftIcon={<Icon as={AiOutlinePlus} />}
              onClick={() => setState('isOpenModal', true)}
            >
              Tambah Pemateri
            </Button>
          ) : (
            <Box />
          )}
          <Stack direction="row" spacing={2}>
            <InputGroup w="250px" mt={{ base: 4, md: 0 }}>
              <InputLeftElement pointerEvents="none">
                <FaSearch />
              </InputLeftElement>
              <Input
                type="text"
                placeholder="Cari Disini..."
                onChange={(e) => {
                  setState('keyword', e.target.value);
                  setState('page', 1);
                }}
                _focus={{
                  ring: '1',
                  ringColor: 'green.700',
                  borderColor: 'green.700',
                }}
              />
            </InputGroup>
            {canMutate && (
              <Flex flexDirection="column">
                <Flex>
                  <Button
                    colorScheme="blue"
                    leftIcon={<Icon as={FiDownload} />}
                    ml={3}
                    onClick={() => generateExcel(id)}
                    isLoading={isLoadingGenerateExcel}
                    isDisabled={isLoadingGenerateExcel}
                  >
                    Generate
                  </Button>
                  <Button
                    colorScheme="green"
                    leftIcon={<Icon as={FiDownload} />}
                    ml={3}
                    onClick={() => downloadExcel(id)}
                    isLoading={isLoadingDownloadExcel}
                    isDisabled={isGenerateJobRunning || isLoadingDownloadExcel}
                  >
                    Download
                  </Button>
                </Flex>
                {generatePengetahuanId && (
                  <Text
                    color="green.400"
                    fontSize="xs"
                    display="flex"
                    ml={3}
                    mt={2}
                  >
                    <BiCheckCircle size={16} /> Generate Telah Selesai
                  </Text>
                )}
              </Flex>
            )}
          </Stack>
        </Flex>
        <DataTable
          data={listData}
          columns={columns}
          customStyles={customStyles}
          progressPending={isLoadingData}
          progressComponent={<Loader />}
          noDataComponent="Data tidak ditemukan"
          pagination
          paginationRowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
          paginationPerPage={perPage}
          paginationServer
          paginationTotalRows={listData.length > 0 ? totalListData : 0}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
        />
      </Box>

      {/* modal */}
      <ModalTteSertifikat
        isOpen={isOpenModalTteSertifikat}
        onClose={() => {
          setState('isOpenModalTteSertifikat', false);
          setState('accountTTESelected', null);
        }}
        onSubmit={() => tteSertifikatPemateri()}
        selectedAccount={accountTTESelected}
        onAccountChange={(option) => setState('accountTTESelected', option)}
        isLoading={isLoadingTTEPemateri}
      />
    </>
  );
};

export default KontenPemateri;
